document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.pz-search-form');
  const input = document.querySelector('.pz-search-input');
  const resultsBox = document.querySelector('.pz-search-results');

  if (!form || !input || !resultsBox) return;

  let timer;

  input.addEventListener('input', () => {
    clearTimeout(timer);

    const term = input.value.trim();

    if (term.length < 2) {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
      return;
    }

    timer = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(term + ' tag:"Pep & Zip"')}&resources[type]=product&resources[limit]=6`)
        .then(response => response.json())
        .then(data => {
          const products = data.resources.results.products || [];

          if (!products.length) {
            resultsBox.hidden = true;
            resultsBox.innerHTML = '';
            return;
          }

          resultsBox.innerHTML = products.map(product => `
            <a class="pz-search-result" href="${product.url}">
              ${product.image ? `<img src="${product.image}" alt="">` : ''}
              <span>${product.title}</span>
            </a>
          `).join('');

          resultsBox.hidden = false;
        });
    }, 200);
  });

  form.addEventListener('submit', e => {
    e.preventDefault();

    const term = input.value.trim();
    if (!term) return;

    window.location.href =
      `/search?type=product&q=${encodeURIComponent(term + ' tag:"Pep & Zip"')}`;
  });
});